import { Card } from 'primereact/card';

export default function Bookmarks(){
	
	return (
		<div className="Bookmarks">
			<h2> <i className="pi pi-bookmark "></i> Bookmarks </h2>
			<Card className="contractItem" width="100%" > TODO: Implement Bookmark</Card>
		</div>

		)

}
